import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import _ from 'lodash';
import moment from 'moment';
import { getSchemaByKeyArray } from '@/utils/common';
const ATTRIBUTE_ID = '_attributes';
export function toODataDate(val, format = 'YYYY-MM-DD') {
  return moment(val, format).format('YYYY-MM-DDTHH:mm:ss');
}
export function odataTimeToString(val, format = 'HH:mm:ss') {
  if (_.isEmpty(val)) {
    return null;
  }
  if (val.indexOf('P') !== 0) {
    return val;
  }
  const duration = moment.duration(val);
  const hours = _.padStart(duration.get('hours').toString(), 2, '0');
  const minutes = _.padStart(duration.get('minutes').toString(), 2, '0');
  const seconds = _.padStart(duration.get('seconds').toString(), 2, '0');
  return `${hours}:${minutes}:${seconds}`;
}
export function odataDateToString(val = '', format = 'YYYY-MM-DD') {
  if (_.isEmpty(val)) {
    return null;
  }
  const regex15 = /\d{15}/g;
  const regex14 = /\d{14}/g;
  const regex13 = /\d{13}/g;
  const regex12 = /\d{12}/g;
  let found;
  if (!_.isEmpty(val.match(regex15))) {
    found = val.match(regex15);
  } else if (!_.isEmpty(val.match(regex14))) {
    found = val.match(regex14);
  } else if (!_.isEmpty(val.match(regex13))) {
    found = val.match(regex13);
  } else if (!_.isEmpty(val.match(regex12))) {
    found = val.match(regex12);
  }
  if (found && found.length > 0) {
    const miliseconds = _.toNumber(found[0]) / 1000;
    const res = moment.unix(miliseconds).format(format);
    return res;
  }
  // 否则返回原值
  return val;
}
export function transformEntityContainer(serviceId, odataEntityContainer) {
  const ret = {
    EntitySet: {}
  };
  let {
    EntitySet
  } = odataEntityContainer;
  if (!_.isEmpty(EntitySet) && !Array.isArray(EntitySet)) {
    EntitySet = [EntitySet];
  }
  EntitySet.forEach(entity => {
    const {
      _attributes
    } = entity;
    const {
      EntityType,
      Name
    } = _attributes;
    ret.EntitySet[Name] = EntityType.replace(`${serviceId}.`, '');
  });
  return ret;
}
/**
 * 将odata的entity type转换为json schema
 * @param {*} entityTypeArray
 * @returns
 */
export function transformEntityTypeList(entityTypeArray) {
  const returnVal = {};
  const ATTRIBUTE = '_attributes';
  // 希望替换的key的前缀
  const SAP_ENTRIES_KEY_PREFIX = 'sap:';
  // 希望替换的值的前缀
  const SAP_ENTRIES_TYPE_VALUE_PREFIX = 'Edm.';
  // key的转换类型
  const ENTRIES_VALUE_TYPE = {
    minlength: Number,
    maxlength: Number
  };
  const ENTRIES_KEY_TO_SCHEMA_KEY = {
    label: 'title',
    minlength: 'minLength',
    maxlength: 'maxLength'
  };
  // 排除的key
  const EXCLUDE_KEY_ARRAY = ['unicode'];
  entityTypeArray.forEach(entity => {
    const schema = {
      properties: {},
      title: ''
    };
    // key
    const entityKey = entity[ATTRIBUTE].Name;
    // title
    // TODO title 为undefined
    schema.title = entity[ATTRIBUTE][`${SAP_ENTRIES_KEY_PREFIX}label`];
    // properties
    let entityPropertyArray = _.get(entity, 'Property', []);
    if (!Array.isArray(entityPropertyArray)) {
      entityPropertyArray = [entityPropertyArray];
    }
    entityPropertyArray.forEach(property => {
      const {
        _attributes
      } = property;
      const schemaPropertyKey = _attributes.Name;
      schema.properties[schemaPropertyKey] = {};
      const properties = schema.properties[schemaPropertyKey];
      Object.keys(_attributes).forEach(key => {
        let propertyKey = key.toLowerCase();
        // 移除key的前缀
        if (propertyKey.indexOf(SAP_ENTRIES_KEY_PREFIX) === 0) {
          propertyKey = propertyKey.replace(SAP_ENTRIES_KEY_PREFIX, '');
        }
        // 排除指定的key
        if (_.findIndex(EXCLUDE_KEY_ARRAY, item => item === propertyKey) !== -1) {
          return;
        }
        if (propertyKey !== 'name') {
          let propertyValue = _attributes[key];
          // 移除值的前缀
          if (propertyValue.indexOf(SAP_ENTRIES_TYPE_VALUE_PREFIX) === 0) {
            propertyValue = propertyValue.replace(SAP_ENTRIES_TYPE_VALUE_PREFIX, '');
          }
          // 格式化
          if (typeof propertyValue === 'string' && propertyKey !== 'label') {
            propertyValue = propertyValue.toLowerCase();
          }
          if (typeof ENTRIES_VALUE_TYPE[propertyKey] === 'function' && !_.isEmpty(propertyValue)) {
            try {
              if (ENTRIES_VALUE_TYPE[propertyKey] === Number) {
                propertyValue = parseInt(propertyValue, 10);
              }
            } catch (err) {
              console.error('Schema解析错误，请联系SAP开发人员。');
            }
          }
          if (propertyValue === 'false') {
            propertyValue = false;
          } else if (propertyValue === 'true') {
            propertyValue = true;
          }
          // 转换key为对应schema的key
          if (ENTRIES_KEY_TO_SCHEMA_KEY[propertyKey]) {
            propertyKey = ENTRIES_KEY_TO_SCHEMA_KEY[propertyKey];
          }
          if (propertyKey === 'type') {
            if (propertyValue === 'datetime' || propertyValue === 'time') {
              if (propertyValue === 'datetime') {
                propertyValue = 'date';
              }
              properties.format = propertyValue;
              propertyValue = 'string';
            }
            if (propertyValue.indexOf('int') >= 0 || propertyValue.indexOf('byte') >= 0) {
              propertyValue = 'number';
            }
            if (propertyValue.indexOf('decimal') >= 0) {
              propertyValue = 'string';
            }
          }
          properties[propertyKey] = propertyValue;
        }
      });
    });
    returnVal[entityKey] = schema;
  });
  return returnVal;
}
/**
 * 将字符串形式的JavaScript时间转换为odata时间
 * @param {String} val 值
 * @returns String 格式为ISO 8601 durations
 */
export function toODataTime(val) {
  if (!_.isNumber(val) && _.isEmpty(val)) {
    return val;
  }
  return moment.duration(val).toISOString();
}
/**
 * 根据 schemaArray 数组及 excludeSchemaArray 计算真实的schema
 * @param schema 完整的schema
 * @param schemaArray 需展示的字段列表（字符串或对象列表） (对应的formSchema、tableSchema属性)
 * @param excludeSchemaArray 不需展示的字段列表（字符串列表）
 *
 * @return {*} 最终的 JSON Schema
 */
export function calculateSchema(schema, schemaArray, excludeSchemaArray) {
  if (!schema || !schema.properties) {
    return {
      properties: {}
    };
  }
  // if (schemaArray && _.isArray(schemaArray) && schemaArray.length > 0) {
  if (schemaArray && _.isArray(schemaArray)) {
    return {
      ...schema,
      properties: getSchemaByKeyArray(schema, schemaArray).properties
    };
  }
  const remainKeys = Object.keys(schema.properties);
  if (excludeSchemaArray && _.isArray(excludeSchemaArray) && excludeSchemaArray.length > 0) {
    _.remove(remainKeys, key => excludeSchemaArray.indexOf(key) >= 0);
  }
  return {
    ...schema,
    properties: getSchemaByKeyArray(schema, remainKeys).properties
  };
}
// 格式化日期格式
export function formatDateTime(date) {
  if (!date) {
    return null;
  }
  const reg = /^\d{4}-\d{2}-\d{2}$/g;
  let d;
  if (reg.test(date)) {
    // eg: 2021-05-10 ------> 2021-05-10T00:00:00
    d = toODataDate(date);
  } else if (date.startsWith('/Date')) {
    // eg:'/Date(1620604800000)/' ------------> 2021-05-10
    const d1 = getFormatDate(date);
    // eg: 2021-05-10 ------> 2021-05-10T00:00:00
    d = toODataDatemmss(d1);
  }
  return d;
}
export function formatDateTimeAddT(date) {
  if (!date) {
    return null;
  }
  const reg = /^\d{4}-\d{2}-\d{2}$/g;
  let d;
  if (reg.test(date)) {
    // eg: 2021-05-10 ------> 2021-05-10T00:00:00
    d = toODataDate(date);
  } else if (date.startsWith('/Date')) {
    // eg:'/Date(1620604800000)/' ------------> 2021-05-10
    const d1 = getFormatDate(date);
    // eg: 2021-05-10 ------> 2021-05-10T00:00:00
    d = toODataDatemmss(d1);
  }
  return d;
}
// 获取日期
function getFormatDate(time) {
  if (!time) {
    return '';
  }
  const reg = /^\d{4}-\d{2}-\d{2}$/g;
  if (reg.test(time)) {
    return time;
  }
  if (time.startsWith('/Date')) {
    const date = new Date(Number(time.replace(/\D/g, '')));
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const sdate = `0${date.getDate()}`.slice(-2);
    // 拼接
    const result = `${year}-${month}-${sdate}`;
    return result;
  }
  return '';
}
function toODataDatemmss(val, format = 'YYYY-MM-DD') {
  if (!_.isNumber(val) && _.isEmpty(val)) {
    return val;
  }
  return moment(val, format).format('YYYY-MM-DDTHH:mm:ss');
}
export function toDatemmss(val, format = 'YYYYMMDDHHmmss') {
  if (!_.isNumber(val) && _.isEmpty(val)) {
    return val;
  }
  return moment(val, format).format('YYYY-MM-DD HH:mm:ss');
}